import { render, staticRenderFns } from "./AddonPage.vue?vue&type=template&id=41a39590&"
import script from "./AddonPage.vue?vue&type=script&lang=js&"
export * from "./AddonPage.vue?vue&type=script&lang=js&"
import style0 from "./AddonPage.vue?vue&type=style&index=0&id=41a39590&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports